import { PageHeader } from '../components/layout/PageHeader';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/Card';
import { useTheme } from '../context/ThemeContext';
import { icons } from '../components/ui/Icons';

export function UserSettingsPage() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <PageHeader
        title="Persönliche Einstellungen"
        description="Darstellung und persönliche Voreinstellungen für Ihre aktuelle Sitzung."
        breadcrumbs={[{ label: 'Startseite', href: '/' }, { label: 'Persönliche Einstellungen' }]}
      />

      <Card>
        <CardHeader>
          <CardTitle>Darstellung</CardTitle>
          <CardDescription>Wählen Sie eine ruhige, für Ihren Arbeitsplatz passende Darstellung.</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col gap-4 border-t border-neutral-200 pt-4 sm:flex-row sm:items-center sm:justify-between dark:border-neutral-700">
            <div className="flex items-center gap-3">
              <div className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-50 text-primary-700 dark:bg-primary-900/30 dark:text-primary-300">
                {isDark ? <icons.Moon className="h-4 w-4" aria-hidden="true" /> : <icons.Sun className="h-4 w-4" aria-hidden="true" />}
              </div>
              <div>
                <p className="text-sm font-medium text-neutral-900 dark:text-neutral-100">{isDark ? 'Dunkle Darstellung' : 'Helle Darstellung'}</p>
                <p className="text-sm text-neutral-500 dark:text-neutral-400">Die Einstellung wird auf diesem Gerät gespeichert.</p>
              </div>
            </div>
            <button type="button" onClick={toggleTheme} className="btn-outline w-fit">Darstellung wechseln</button>
          </div>
        </CardContent>
      </Card>

      <Card variant="bordered">
        <CardContent className="flex items-start gap-3">
          <icons.Info className="mt-0.5 h-5 w-5 flex-shrink-0 text-neutral-500" aria-hidden="true" />
          <p className="text-sm text-neutral-600 dark:text-neutral-300">Profil- und Berechtigungsdaten werden zentral verwaltet. Änderungen daran erfolgen nicht in dieser Ansicht.</p>
        </CardContent>
      </Card>
    </div>
  );
}
